import React from 'react';
import { Link } from 'react-router-dom';
import './Partners.css';
import { partners, awards } from '../data/site';

const tiers = [
  { tier: 'Hyperscalers', items: ['Microsoft Azure', 'Amazon Web Services', 'Google Cloud'], text: 'Active partnerships across the three major hyperscalers.' },
  { tier: 'Data Platforms', items: ['Databricks', 'Snowflake', 'Confluent', 'dbt Labs'], text: 'Strategic alliances with the platforms running our clients\' data.' },
  { tier: 'AI / Frontier Labs', items: ['OpenAI', 'Anthropic', 'NVIDIA', 'Tecton'], text: 'Enterprise-grade integrations with frontier AI providers and tooling.' },
  { tier: 'Specialist', items: ['MongoDB', 'Pinecone', 'Weaviate', 'Hugging Face'], text: 'Specialist alliances for vector search, embeddings, and inference at scale.' },
];

const Partners = () => {
  return (
    <div className="partners-page page-shell">
      <section className="pn-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Partners</span>
          <h1>
            The technology partners <span className="gradient-text serif-accent">our clients run on.</span>
          </h1>
          <p>
            Dalytix is platform-agnostic by design but deeply credentialed with the platforms our
            clients rely on — across hyperscalers, data platforms and frontier AI providers.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <div className="pn-tier-grid">
            {tiers.map((t) => (
              <article className="pn-tier-card professional-card" key={t.tier}>
                <span className="eyebrow-tag">{t.tier}</span>
                <p>{t.text}</p>
                <div className="pn-tier-items">
                  {t.items.map((i) => (<span className="pn-pill" key={i}>{i}</span>))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section pn-all section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">All ecosystems</span>
          <h2 className="section-title">Working across the modern AI &amp; data stack.</h2>
          <div className="pn-pill-grid">
            {partners.map((p) => (<span className="pn-pill-dark" key={p}>{p}</span>))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <span className="section-eyebrow">Recognition</span>
          <h2 className="section-title">Year-one recognition from the platforms we work with.</h2>
          <ul className="pn-awards">
            {awards.map((a) => (
              <li key={a}><img src="/images/award-badge.svg" alt="" /><span>{a}</span></li>
            ))}
          </ul>
        </div>
      </section>

      <section className="pn-cta">
        <div className="site-container-wide professional-card">
          <h2>Want to partner with Dalytix?</h2>
          <p>Whether you are a platform, ISV, agency or VC — we are open to high-quality alliances.</p>
          <Link to="/contact" className="btn-primary-large">Contact our partner team</Link>
        </div>
      </section>
    </div>
  );
};

export default Partners;
